export default {
  getUid: state => state.uid,
  getErrorState: state => state.errorState,
  getIsAuth: state => state.isAuth,
  getMenus: state => state.menus,
  getLocale: state => state.locale,
  getParams: state => state.params,
  getAuthInfo: state => state.authInfo,
  getHighestRole: state => state.highestRole,
  getApiErrorCode: state => state.apiErrorCode,
  getLogoutCalled: state => state.logoutCalled,
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js